import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "vant/es/icon/style";
import _Icon from "vant/es/icon";
import "core-js/modules/es.array.slice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GroupBuyingItem from './item.vue';
import useBoolean from '@/hooks/useBoolean';
import VueCompositionAPI, { ref, onMounted, watch } from '@vue/composition-api';
import Vue from 'vue';
import Popup from '@/components/detail-new/Popup.vue';
import { clickShowAllLog, showGroupByLog, showPopupLog, showSeeAllLog } from './eventTracking.js';
Vue.use(_Icon);
Vue.use(Popup);
Vue.use(VueCompositionAPI);
export default {
  components: {
    GroupBuyingItem: GroupBuyingItem,
    Popup: Popup
  },
  props: ['list', 'performanceId', 'cityId'],
  setup: function setup(props) {
    /**
     * 当list小于等于2时，直接展示
     * 当list长度2-5时：默认展开2，点击查看全部团购可以查看全部，也可以收起
     */
    var originList = ref(props.list);
    var showList = ref([]);
    var _useBoolean = useBoolean(),
      _useBoolean2 = _slicedToArray(_useBoolean, 2),
      showUpDown = _useBoolean2[0],
      handleShowUpDown = _useBoolean2[1].setTrue;
    var _useBoolean3 = useBoolean(),
      _useBoolean4 = _slicedToArray(_useBoolean3, 2),
      isUp = _useBoolean4[0],
      toggle = _useBoolean4[1].toggle;
    if (originList.value.length > 1) {
      showTop1();
      handleShowUpDown();
    } else {
      showList.value = originList.value;
    }
    function showTop1() {
      showList.value = originList.value.slice(0, 1);
    }
    var handleClickUpDown = function handleClickUpDown() {
      if (!isUp.value) {
        showList.value = originList.value;
        clickShowAllLog(props.performanceId);
      } else {
        showTop1();
      }
      toggle();
    };
    //list>=5 展示弹窗
    var _useBoolean5 = useBoolean(),
      _useBoolean6 = _slicedToArray(_useBoolean5, 2),
      show = _useBoolean6[0],
      _useBoolean6$ = _useBoolean6[1],
      setTrue = _useBoolean6$.setTrue,
      handleClose = _useBoolean6$.setFalse;
    var handleOpenPopup = function handleOpenPopup() {
      setTrue();
      clickShowAllLog(props.performanceId);
    };
    onMounted(function () {
      var _props$list;
      showGroupByLog(props.performanceId);
      if (((_props$list = props.list) === null || _props$list === void 0 ? void 0 : _props$list.length) > 1) {
        showSeeAllLog(props.performanceId);
      }
    });
    watch(show, function (val) {
      if (val === true) {
        showPopupLog(props.performanceId);
      }
    });
    return {
      show: show,
      showList: showList,
      showUpDown: showUpDown,
      isUp: isUp,
      handleClickUpDown: handleClickUpDown,
      originList: originList,
      handleOpenPopup: handleOpenPopup,
      handleClose: handleClose
    };
  },
  methods: {
    onCountDownFinish: function onCountDownFinish() {
      this.$emit('onCountDownFinish');
    }
  }
};